import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { StatusBadge } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/Loading";
import { GraduationCap, Clock, LogOut, RefreshCw } from "lucide-react";

export default function PendingSupervisor() {
  const { user, logout, setUser } = useAuth();
  const [req, setReq] = useState(null);
  const [checking, setChecking] = useState(false);

  const loadReq = () => api.get("/supervisor-requests/mine").then((r) => setReq(r.data)).catch(() => {});
  const refreshRole = async () => {
    setChecking(true);
    try { const r = await api.get("/auth/me"); setUser(r.data); } catch (e) {}
    await loadReq();
    setChecking(false);
  };
  useEffect(() => { loadReq(); const t = setInterval(refreshRole, 20000); return () => clearInterval(t); }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-lg animate-scale-in rounded-2xl border border-slate-100 bg-card p-8 text-center soft-shadow" data-testid="pending-supervisor">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-navy text-gold"><GraduationCap className="h-8 w-8" /></div>
        <h1 className="mt-5 font-heading text-2xl font-extrabold text-navy">طلب الإشراف قيد المراجعة</h1>
        <p className="mt-2 leading-relaxed text-slate-500">
          مرحبًا {user?.name}، تم استلام طلبك للحصول على صلاحية مشرف. سيقوم المشرف العام بمراجعته قريبًا.
        </p>
        <div className="mt-5 flex items-center justify-center gap-2">
          <Clock className="h-5 w-5 text-amber-500" />
          <span className="text-sm text-slate-500">الحالة الحالية:</span>
          <StatusBadge status={req?.status || "pending"} />
        </div>
        {req?.status === "rejected" && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-600">نأسف، لم تتم الموافقة على طلبك. يمكنك التواصل مع الإدارة.</p>}
        <div className="mt-6 flex justify-center gap-3">
          <Button data-testid="refresh-status" onClick={refreshRole} disabled={checking} className="rounded-xl bg-navy hover:bg-navy-light">
            {checking ? <Spinner className="h-5 w-5 border-white/40 border-t-white" /> : <><RefreshCw className="me-2 h-4 w-4" /> تحديث الحالة</>}
          </Button>
          <Button data-testid="pending-logout" onClick={logout} variant="outline" className="rounded-xl"><LogOut className="me-2 h-4 w-4" /> خروج</Button>
        </div>
      </div>
    </div>
  );
}
